import { Box } from '@mui/material';
import React from 'react';

import { MobileBody2, MobileCaption } from '../Typography';

export interface ChatMessageBubbleProps {
  align: 'left' | 'right';
  primaryText: string;
  messageText: string;
  timestamp: Date | string | number;
  loading?: boolean;
}

const toDate = (value: Date | string | number): Date =>
  value instanceof Date ? value : new Date(value);

const ChatMessageBubble: React.FC<ChatMessageBubbleProps> = ({
  align,
  primaryText,
  messageText,
  timestamp,
  loading = false,
}) => {
  const date = toDate(timestamp);
  const timeStr = date.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
        width: '100%',
      }}
    >
      <Box
        sx={{
          maxWidth: '85%',
          borderRadius: 2,
          px: 1.5,
          py: 1.25,
          backgroundColor: align === 'right' ? 'grey.200' : 'background.paper',
          boxShadow: 1,
          border: 1,
          borderColor: 'divider',
        }}
      >
        <MobileCaption
          component="span"
          sx={{
            display: 'block',
            color: 'text.secondary',
            fontWeight: 600,
            fontSize: '0.6875rem',
            mb: 0.5,
          }}
        >
          {primaryText}
        </MobileCaption>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          <MobileBody2
            component="span"
            sx={{
              color: 'text.primary',
              fontSize: '0.875rem',
              flex: 1,
              minWidth: 0,
            }}
          >
            {messageText}
          </MobileBody2>
          {loading ? (
            <Box
              component="span"
              sx={{
                width: 12,
                height: 12,
                flexShrink: 0,
                borderRadius: '50%',
                border: 1.5,
                borderColor: 'primary.main',
                borderTopColor: 'transparent',
                animation: 'spin 0.8s linear infinite',
                '@keyframes spin': {
                  to: { transform: 'rotate(360deg)' },
                },
              }}
            />
          ) : (
            <MobileCaption
              component="span"
              sx={{
                whiteSpace: 'nowrap',
                flexShrink: 0,
                color: 'text.secondary',
                fontSize: '0.6875rem',
              }}
            >
              {timeStr}
            </MobileCaption>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ChatMessageBubble;
